import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, from, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

export class LazyTranslateLoader implements TranslateLoader {
  constructor(private resources: string[]) {}

  public loadResource(resource: string, lang: string): Observable<any> {
    return from(import(`${resource + lang}.json`));
  }

  public getTranslation(lang: string): Observable<any> {
    const requests = this.resources.map(resource =>
      this.loadResource(resource, lang),
    );

    return forkJoin(requests).pipe(
      concatMap(responseArray => of(Object.assign({}, ...responseArray))),
    );
  }
}
